import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link, Stack } from '@mui/material';
import { PhoneIcon, TelegramColorIcon } from 'framework/ui/mui-builder';
import type { ApplicationDetails } from '../../shared/types';
import { safeExternalHref } from 'framework/utils';

type ContactInformationSectionProps = {
  application: ApplicationDetails;
};

const contactIconSx = { fontSize: 20, color: 'text.secondary' };
const socialIconSx = { fontSize: 24 };

const ContactInformationSection = ({ application }: ContactInformationSectionProps) => {
  const socialLinks = [
    { id: 'linkedin', icon: <LinkedInIcon color="info" sx={socialIconSx} />, url: application.linkedinUrl },
    { id: 'telegram', icon: <TelegramColorIcon sx={socialIconSx} />, url: application.telegramUrl },
  ].filter(({ url }) => Boolean(url));

  const contacts = [
    {
      id: 'phone',
      icon: <PhoneIcon sx={contactIconSx} />,
      value: application.phone,
      href: `tel:${application.phone}`,
      addon: socialLinks.length ? (
        <Stack direction="row" alignItems="center" gap={0.5} sx={{ ml: 'auto' }}>
          {socialLinks.map(link => (
            <Link key={link.id} href={safeExternalHref(link.url)} target="_blank" rel="noopener" display="flex">
              {link.icon}
            </Link>
          ))}
        </Stack>
      ) : null,
    },
    {
      id: 'email',
      icon: <AlternateEmailIcon sx={contactIconSx} />,
      value: application.email,
      href: `mailto:${application.email}`,
      addon: null,
    },
  ].filter(({ value }) => Boolean(value));

  return (
    <Stack gap={1.25} sx={{ py: 1.5 }}>
      {contacts.map(contact => (
        <Stack key={contact.id} direction="row" alignItems="center" gap={1.25}>
          {contact.icon}
          <Link href={contact.href} variant="body1" underline="hover">
            {contact.value}
          </Link>
          {contact.addon}
        </Stack>
      ))}
    </Stack>
  );
};

export default ContactInformationSection;
